export default __webpack_public_path__ + "static/media/mobile-bg2.9b3f1c47.jpg";